import { render, staticRenderFns } from "./timeout.vue?vue&type=template&id=276c21f1"
import script from "./timeout.vue?vue&type=script&lang=js"
export * from "./timeout.vue?vue&type=script&lang=js"
import style0 from "./timeout.vue?vue&type=style&index=0&id=276c21f1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports